























import Vue from 'vue';

import store from '@/store';

import { WebRequestStatus } from '@/models';
import { BasePacket, Badge, Objective, Outcome } from '@/models/packet';
import { IconData } from '@/icons';

import MultiPointPacketEditor from '@/components/MultiPointPacketEditor.vue';

export default Vue.extend({
  components: {
    MultiPointPacketEditor
  },

  data() {
    return {
      createObjectiveStatus: WebRequestStatus.READY,
      createIndicatorStatus: WebRequestStatus.READY,
      basicInfoStatus: WebRequestStatus.READY
    };
  },

  computed: {
    packet(): BasePacket {
      return store.state.multiPoint.packet;
    },

    statusedObjectives(): [Objective, WebRequestStatus][] {
      return this.packet.objectives.map(o => [o, WebRequestStatus.READY]);
    },

    statusedOutcomes(): [Outcome, WebRequestStatus][] {
      return this.packet.outcomes.map(o => [o, WebRequestStatus.READY]);
    },

    statusedBadges(): [Badge, WebRequestStatus][] {
      return store.state.multiPoint.badges.map(badge => [
        badge,
        WebRequestStatus.READY
      ]);
    }
  },

  methods: {
    createObjective(details: {
      name: string;
      description: string;
      iconData: IconData;
    }) {
      store.dispatch.multiPoint.createObjective(details);
    },

    createIndicator(indicator: {
      index: number;
      value: string;
      color: string;
    }) {
      store.dispatch.multiPoint.createMultiPointIndicator(indicator);
    },

    updateObjective(objective: Objective) {
      store.dispatch.multiPoint.updateObjective(objective);
    },

    updateIndicator(outcome: Outcome) {
      store.dispatch.multiPoint.updateOutcome(outcome);
    },

    updateBadge(badge: Badge) {
      store.dispatch.multiPoint.updateBadge(badge);
    },

    updateBasicInfo(packet: BasePacket) {
      store.dispatch.multiPoint.updateMultiPointBasicInfo(packet);
    },

    deleteIndicator(outcome: Outcome) {
      store.dispatch.multiPoint.deleteOutcome(outcome);
    },

    deleteObjective(objective: Objective) {
      store.dispatch.multiPoint.deleteObjective(objective);
    }
  }
});
